import type React from "react";
import { useRef } from "react";

import { WidgetContainer } from "app/components/React/WidgetContainer/WidgetContainer";
import { translate } from "app/filters/i18nFilter";
import { isCompareMode } from "app/UtilitiesAndConstants/UtilityFunctions/isCompareMode";

import type { DataFormat } from "../../../components/ChannelsOverviewBarChart/ChannelsOverviewBarChartContainerFormat";
import useSubtitleFilters from "../../hooks/useSubtitleFilters";
import type { AddToDashboardButtonProps } from "../../types/types";
import { getPNG } from "../BetaChannelTrafficChartContainer/utils";

import BetaChartViewContent from "./components/BetaChartViewContent";
import { useBetaChannelsOverviewConfig } from "./hooks/useBetaChannelsOverviewConfig";
import { useBetaChannelsOverviewData } from "./hooks/useBetaChannelsOverviewData";

export const BetaChannelsOverviewBarChartContainer: React.FC<{
    addToDashboardButtonProps: AddToDashboardButtonProps;
}> = ({ addToDashboardButtonProps }) => {
    const isCompare = isCompareMode();
    const { data, isLoading } = useBetaChannelsOverviewData();
    const subtitleFilters = useSubtitleFilters();
    const chartRef = useRef<HTMLInputElement>(null);

    const {
        addToDashboardConfig,
        dataFormat,
        viewBy,
        series,
        config,
        totalVisits,
        switcherViewModeConfig,
        switcherByChannelOrDomainConfig,
    } = useBetaChannelsOverviewConfig(data, isCompare, addToDashboardButtonProps);
    return (
        <div
            ref={chartRef}
            data-automation="betaChannelsOverviewBarChartContainer"
        >
            <WidgetContainer
                title={translate("mmx.trafficSources.bar.title")}
                tooltip={translate("mmx.trafficSources.bar.tooltip")}
                isLoading={isLoading}
                loaderWidth={1320}
                loaderHeight={300}
                withBorder
                noData={!data}
                subtitleFilters={subtitleFilters}
                switcherConfig={switcherViewModeConfig}
                onDownloadClick={() => getPNG(chartRef)}
                addToDashboardConfig={addToDashboardConfig}
                downloadProps={{
                    downloadTooltipText: translate("directives.csv.downloadPNG"),
                }}
                switcherViewMode={isCompare ? switcherByChannelOrDomainConfig : undefined}
            >
                <BetaChartViewContent
                    viewBy={viewBy}
                    series={series}
                    config={config}
                    totalVisits={totalVisits}
                    data={data}
                    dataFormat={dataFormat as DataFormat}
                />
            </WidgetContainer>
        </div>
    );
};
